var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tag-input',{ref:"field",attrs:{"id":_vm.identifier,"name":_vm.name,"value":_vm.selected_options,"options":_vm.filtered_options,"disabled":_vm.disabled,"required":_vm.required},on:{"search":_vm.search,"input":_vm.pick,"unpick":_vm.unpick}})
}
var staticRenderFns = []

export { render, staticRenderFns }